module.exports = __webpack_public_path__ + "a1bb63b9594442d3f009622be42480cf.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics1/8.png
// module id = 290
// module chunks = 0